// Simple XSS prevention regex for free text inputs. This is NOT meant to be a robust check,
// rather a basic mitigation for malicious strings. Does not include "script" and "alert" as these
// may appear in free text.
export const XSS_REGEX = /<|>|javascript|onerror|onload|href|src/i;
